import React from 'react'

interface IProps {
  zoomHeight: string
  children: React.ReactNode
  className?: string
  loadImg?: boolean
  [key: string]: any
}

const ImageZoom: React.FC<IProps> = ({
  zoomHeight,
  children,
  className = '',
  loadImg = true,
  ...restProps
}) => {
  const styles: any = {
    display: 'inline-block',
    position: 'relative',
  }

  if (zoomHeight) {
    Object.assign(styles, {
      paddingBottom: zoomHeight,
      width: '100%',
    })
  }

  return (
    <div
      style={styles}
      className={`common-image-zoom ${
        loadImg ? 'g-load-img-wrap' : ''
      } ${className}`}
      {...restProps}
    >
      {children}

      <style jsx>
        {`
          :global(.common-image-zoom) {
            overflow: hidden;
          }
          :global(.common-image-zoom img) {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            overflow: hidden;
            object-fit: cover;
          }
        `}
      </style>
    </div>
  )
}

export default ImageZoom
